import forge from 'node-forge';
import JSONStorageManager, { StorageManagerType } from '../StorageManager/JSONStorageManager';

export interface KeyChain {
    private: string,
    public: string
}

export enum JSEncryptionEncoding {
    "HEX" = "hex",
    "B64" = "base64"
}

export interface JSEncryptionInterface {
    keychain: KeyChain,
    storage: StorageManagerType,
    encoding: JSEncryptionEncoding,
    generateKeyChain(): KeyChain,
    resetKeyChain(clearStorage: boolean): void,
    loadKeyChainFromStorage(): KeyChain | null,
    storeKeyChainToStorage(keychain: KeyChain): void,
    loadKeyChain(): void,
    encrypt(value: string, publicKeyOverload?: string): string,
    decrypt(value: string, privateKeyOverload?: string): string
}



const pki = forge.pki;

const storage: StorageManagerType = JSONStorageManager;

storage.storage.storageKey = "PluginClientKeyChain";

const keychainDefault = {
    private: "",
    public: "",
}

const JSEncryption: JSEncryptionInterface = {
    keychain: keychainDefault,
    storage: storage,
    encoding: JSEncryptionEncoding.HEX,
    generateKeyChain() {
        const pair: forge.pki.rsa.KeyPair = pki.rsa.generateKeyPair({ bits: 2048, workers: 2 });
        const newKeychain: KeyChain = {
            private: pki.privateKeyToPem(pair.privateKey),
            public: pki.publicKeyToPem(pair.publicKey)
        };
        return newKeychain;
    },
    resetKeyChain(clearStorage = false) {
        this.keychain = keychainDefault;
        if (clearStorage) {
            this.storage.removeFromStorage();
        }
    },
    loadKeyChain(forceNew = false) {
        if (this.keychain.public == "" || forceNew) {
            let newKeychain: KeyChain | null = this.loadKeyChainFromStorage();
            if (newKeychain === null) {
                newKeychain = this.generateKeyChain();
                this.storeKeyChainToStorage(newKeychain);
            }

            this.keychain = newKeychain;
        }
    },
    loadKeyChainFromStorage() {

        const storedChain: string | null = this.storage.getFromStorage();
        return storedChain === null ? null : JSON.parse(storedChain);
    },
    storeKeyChainToStorage(keychain: KeyChain) {
        this.storage.storeToStorage(JSON.stringify(keychain));
    },
    encrypt(value, publicKeyOverload) {
        let pubKey;
        if (publicKeyOverload) {
            pubKey = publicKeyOverload;
        } else {
            this.loadKeyChain();
            pubKey = this.keychain.public;
        }
        this.loadKeyChain();
        return pki.publicKeyFromPem(pubKey).encrypt(value);
    },
    decrypt(digest, privateKeyOverload) {
        let pk;
        if (privateKeyOverload) {
            pk = privateKeyOverload;
        } else {
            this.loadKeyChain();
            pk = this.keychain.private;
        }

        return pki.privateKeyFromPem(pk).decrypt(digest);
    }
}

export default JSEncryption;
